<template>
  <div>
    <div class="admin-header">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h1 class="white">Edit Product</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="container" v-if="processing">
      <div class="row space-loader d-flex align-items-center justify-content-center">
        <b-spinner style="width: 6rem; height: 6rem;" label="Large Spinner"></b-spinner>
      </div>
    </div>
    <ProductForm v-else v-bind:productID="$route.params.id" v-on:submitted="updateProduct" />
  </div>
</template>

<script>
import api from "../../api/api";
import ProductForm from "@/components/Admin/ProductForm.vue";
export default {
  components: {
    ProductForm,
  },
  data: function () {
    return {
      processing: false,
    };
  },
  methods: {
    updateProduct(data) {
      this.processing = true;
      api
        .updateProduct(data)
        .then(() => {
          this.$router.push("/admin/products");
        })
        // .catch((err) => {
        //   console.log(err);
        // })
        .finally(() => {
          this.processing = false;
        });
    },
  },
};
</script>